<template>
    <div class="container">
        <div class="order">
            <div class="search">
                <input
                    v-validate="'required|isOrderNo'"
                    id="orderNoForm"
                    name="orderNoFormMain"
                    v-model="orderNoFormMain"
                    type="text"
                    placeholder="请输入运单号，多个单号用英文逗号（,）分隔"
                    autocomplete="off"
                    :class="{ error: errors.has('orderNoFormMain') }"
                    @keyup.enter="clickgetNo"
                />
                <button
                    id="getNo"
                    @click="getOrderNo"
                    :disabled="errors.has('orderNoFormMain') || clickDisabled"
                >
                    查询
                </button>
            </div>
            <div class="mobile-ver-title" v-if="mobileWidth && dialogVisible">
                操作过于频繁，请输入验证码
            </div>
            <div
                class="ver-img mobile-ver-code"
                v-if="mobileWidth && dialogVisible"
            >
                <el-input
                    v-model="verCode"
                    placeholder="请输入验证码"
                    class="code-input mobile-code-input"
                ></el-input>
                <img :src="verImfMsg.picture" class="mobile-ver-img" />
                <div ref="verImgButton" class="ver-img" @click="getVerImg">
                    <img
                        src="../../images/icon/refresh.png"
                        class="refresh-img"
                    />
                    <span class="another-img">换一张</span>
                </div>
            </div>
            <div class="loading" v-show="loading">
                <img src="../../images/icon/loading.gif" />
            </div>
            <div class="error" v-show="errors.has('orderNoFormMain')">
                <span>请输入正确的运单号</span>
            </div>
            <div v-if="error" class="record-list">{{ errorMessage }}</div>
            <div v-else-if="orderData" class="record-list">
                <div class="total-top">
                    <h3 class="total-title">
                        共查到 {{ orderData.length }} 个关联单号
                    </h3>
                    <span class="top-tip">如需咨询订单详情可联系安得智联物流客服400-000-0056</span>
                </div>
                <div
                    class="custom-order-no"
                    v-for="(custom, oindex) in orderData"
                    :key="custom.customerOrderNo"
                >
                    <h3 class="custom-title" @click="switchAll(custom)">
                        <span class="custom-title-color1">单号：</span>
                        <span class="important-info">{{
                            custom.customerOrderNo
                        }}</span>
                        <span>{{
                            custom.waybills
                                ? "（共" + custom.waybills.length + "个运单）"
                                : "（共1个运单）"
                        }}</span>
                        <img class="ustom-title-btn" :src="custom.showImg" />
                    </h3>
                    <div class="custom-order-container">
                        <template v-if="custom.waybills">
                            <div
                                class="waybill-list"
                                v-for="(waybill, windex) in custom.waybills"
                                :key="waybill.expressNo"
                            >
                                <h5
                                    class="waybill-title"
                                    :class="!waybill.show ? 'closed' : 'opened'"
                                    @click="
                                        showWayBill(
                                            waybill,
                                            custom,
                                            oindex,
                                            windex
                                        )
                                    "
                                >
                                    <span class="custom-title-color1"
                                        >运单号：</span
                                    >
                                    <span>{{ waybill.expressNo }}</span>
                                    <br class="custom-title-br" />
                                    <span class="custom-title-status">{{
                                        waybill.orderStatus
                                    }}</span>
                                    <span class="open-text">{{
                                        !waybill.show ? "展开" : "收起"
                                    }}</span>
                                </h5>
                                <div class="time-line" v-show="waybill.show">
                                    <record-item
                                        :trackings="waybill.trackingsTree"
                                        :stage="waybill.orderStatus"
                                        :polylinePath="waybill.polylinePath"
                                    />
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="waybill-list">
                                <h4 class="order-title">
                                    单号：
                                    <span class="important-info"
                                        >{{ custom.customerOrderNo }} 【{{
                                            custom.orderStatus
                                        }}】</span
                                    >
                                </h4>
                                <div class="time-line">
                                    <record-item
                                        :trackings="custom.trackingsTree"
                                        :stage="custom.orderStatus"
                                    />
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <el-dialog
                title="操作频繁，请完成输入验证码"
                :visible="!mobileWidth && dialogVisible"
                width="300px"
                :before-close="closeDialog"
                :close-on-click-modal="false"
            >
                <el-input
                    v-model="verCode"
                    placeholder="请输入验证码"
                    class="code-input"
                ></el-input>
                <div class="ver-img">
                    <img :src="verImfMsg.picture" width="120" />
                    <div class="ver-img" @click="getVerImg">
                        <img
                            src="../../images/icon/refresh.png"
                            class="refresh-img"
                        />
                        <span class="another-img">换一张</span>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false" size="mini"
                        >取 消</el-button
                    >
                    <el-button type="primary" @click="confirmCode" size="mini"
                        >确 定</el-button
                    >
                </span>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import RecordItem from './recordItem';
import config from '@/config/env.js';
const MIDDLE_PANEL = 360;
const TOP_PANEL = 50;
const BOTTOM_PANEL = 575;
const ENTER_EVENT_CODE = 13;
export default {
    metaInfo: {
        title: '运单查询-安得智联'
    },
    name: 'order',
    props: ['mobileWidth'],
    data() {
        return {
            isMobile: this.COMMON.isMobile,
            orderNoFormMain: '',
            orderData: [],
            error: true,
            errorMessage: '',
            loading: false,
            zhankaiImg: require('../../images/icon/order-icon/pc_zhankai.png'),
            shouqiImg: require('../../images/icon/order-icon/PC_shouqi.png'),
            touchTimer: false,
            startX: 0,
            clickDisabled: false,
            timer: null,
            verImfMsg: {},
            dialogVisible: false,
            verCode: ''
        };
    },
    components: {
        RecordItem
    },

    beforeDestroy() {
        this.bindKeyDown(false);
    },
    methods: {
        bindKeyDown(isbind) {
            isbind ? window.addEventListener('keydown', this.onKeyDown, false) : window.removeEventListener('keydown', this.onKeyDown, false);
        },
        onKeyDown(event) {
            if (event.keyCode === ENTER_EVENT_CODE) {
                this.confirmCode();
            }

        },
        getData() {
            var self = this;
            this.clickDisabled = true;
            this.loading = true;
            this.$http
                .get(`${config.reqiestUrl}/api-lots/public/waybill/tracking/portal`, {
                    // .get('/fe-api/order', {
                    params: {
                        keyword: self.orderNoFormMain.replace(/\s/ig, ''),
                        messageId: this.verImfMsg.messageId || '',
                        code: this.verCode || ''
                    }
                })
                .then(async function (response) {
                    if (!response.data || response.data.code === '010000') {
                        self.orderData = [];
                        self.error = true;
                        self.errorMessage = response.data.msg;
                    } else if (response.data && response.data.code === '0' && response.data.data) {
                        if (!response.data.data.length) {
                            self.orderData = [];
                        }
                        self.verCode = '';
                        self.verImfMsg = {};
                        self.dialogVisible = false;
                        self.error = false;
                        let tempData = response.data.data;
                        if (tempData[0] && tempData[0].waybills && tempData[0].waybills[0]) {
                            // if (tempData[0].waybills[0].dotInfos) {
                            //     tempData[0].waybills[0].dotInfos[0].anntoOrderNo = self.orderNoFormMain.replace(/\s/ig, '');
                            // };// 
                            const polylinePath = await self.getMapData(tempData[0].waybills[0].dotInfos);
                            tempData[0].waybills[0].polylinePath = polylinePath;
                        }
                        for (var i = tempData.length - 1; i >= 0; i--) {
                            tempData[i].showImg = self.zhankaiImg;
                            var tempWaybillData = tempData[i].waybills;
                            if (tempWaybillData && tempWaybillData.length > 0) {
                                for (var j = tempWaybillData.length - 1; j >= 0; j--) {
                                    tempWaybillData[j].show = false;
                                    if (tempWaybillData[j].trackings && tempWaybillData[j].trackings.length > 0) {
                                        tempWaybillData[j].trackingsTree = self.gatherList(tempWaybillData[j].trackings);
                                    }
                                }
                                tempData[0].waybills[0].show = true;
                            } else {
                                tempData[i].trackingsTree = self.gatherList(tempData[i].trackings);
                            }
                        }
                        if (tempData[0]) {
                            tempData[0].showImg = self.shouqiImg;
                        }
                        if (tempData[0] && tempData[0].waybills) {
                            tempData[0].waybills[0].show = true;
                        }
                        self.orderData = tempData;
                    } else if (response.data && response.data.code === '2') {
                        self.getVerImg();
                        //  self.$message.warning(response.data.msg);
                    }
                    if (self.orderData.length <= 1) {
                        window._paq && window._paq.push(['trackEvent', '运单查询', 'click', '单数' + self.orderData.length]);
                    } else {
                        window._paq && window._paq.push(['trackEvent', '运单查询', 'click', '单数' + self.orderData.length + ',' + self.orderNoFormMain]);
                    }
                }).finally(() => {
                    this.loading = false;
                    this.clickDisabled = false;
                });
        },
        // 获取验证码图片
        getVerImg() {
            const _this = this;
            this.$http.get(`${config.reqiestUrl}/api-lots/public/check/captcha/pic`).then(async function (res) {
                if (res.data.code === '0') {
                    _this.verCode = '';
                    _this.dialogVisible = true;
                    _this.verImfMsg = res.data.data;
                }
            });
        },
        confirmCode() {
            if (!this.verCode.length) {
                this.dialogVisible && this.$message.warning('请输入验证码');
                return;
            }
            this.getData();
        },
        gatherList(list) {
            const listKey = [];
            let index = 0;
            for (let i = 0; i < list.length; i++) {
                if (list[i].stage === list[i - 1 >= 0 ? i - 1 : 0].stage && index === 0) {
                    index = 0;
                    if (!listKey[0]) {
                        listKey[0] = [];
                    }
                    listKey[0].push(list[i]);
                } else {
                    if (list[i].stage !== list[i - 1 >= 0 ? i - 1 : 0].stage) {
                        index += 1;
                    }
                    if (!listKey[index]) {
                        listKey[index] = [];
                    }
                    listKey[index].push(list[i]);
                }
            }
            return listKey;
        },
        getOrderNo() {
            const that = this;
            this.$validator.validateAll().then(result => {
                if (result) {
                    if (this.timer) {
                        clearTimeout(this.timer);
                        this.timer = null;
                    }
                    this.timer = setTimeout(() => {
                        that.trackingList = [];
                        that.error = true;
                        that.errorMessage = '';
                        history.pushState(null, null, '?orderNoFormMain=' + that.orderNoFormMain);
                        that.getData();
                    }, 500);
                }
            });
        },
        clickgetNo() {
            document.querySelector('#getNo').click();
        },
        async showWayBill(waybill, custom, o, w) {
            waybill.show = !waybill.show;
            const opens = custom.waybills.filter(item => { return item.show === true; });
            if (waybill.show) {
                custom.showImg = this.shouqiImg;
                if (!waybill.polylinePath && waybill.polylinePath.length) {
                    const polylinePath = await this.getMapData(waybill.dotInfos);
                    const ttorder = JSON.parse(JSON.stringify(this.orderData));
                    ttorder[o].waybills[w].polylinePath = polylinePath;
                    this.orderData = ttorder;
                }
            } else if (opens.length === 0) {
                custom.showImg = this.zhankaiImg;
            }
        },
        async getMapData(data) {
            if (data) {
                let resData = [];
                await this.$http
                    .post(`${config.reqiestUrl}/api-lots/public/waybill/dot/portal`, data).then(res => {
                        if (res && res.data && res.data.code === '0') {
                            res.data.data.forEach(item => {
                                item.lng = item.longitude;
                                item.lat = item.latitude;
                                item.time = item.businessTime;
                            });
                            resData = res.data.data;
                        }
                    });
                return resData;
            } else {
                return [];
            }
        },
        switchAll(custom) {
            // if (this.isMobile) return;
            const opens = custom.waybills.filter(item => { return item.show === true; });
            if (opens.length > 0) {
                custom.waybills.map(item => {
                    item.show = false;
                    custom.showImg = this.zhankaiImg;
                });
            } else {
                custom.waybills.map(item => {
                    item.show = true;
                    custom.showImg = this.shouqiImg;
                });
            }
        },
        boxTouchStart(e) {
            this.startX = e.changedTouches[0].pageX;
            this.startY = e.changedTouches[0].pageY;
        },
        boxTouchMove(direction) {
            if (!this.widthTimer) {
                const panelNode = document.getElementsByClassName('record-container')[0];
                const judje = this.startY > panelNode.offsetTop && this.startY < (panelNode.offsetTop + 30); //手指在bar上时才有效果
                if (!judje) return;
                if (direction === 'up') {
                    if (panelNode.offsetTop === MIDDLE_PANEL) {
                        panelNode.style.top = TOP_PANEL + 'px';
                    } else if (panelNode.offsetTop === BOTTOM_PANEL) {
                        panelNode.style.top = MIDDLE_PANEL + 'px';
                    }
                } else if (direction === 'down') {
                    if (panelNode.offsetTop === TOP_PANEL) {
                        panelNode.style.top = MIDDLE_PANEL + 'px';
                    } else if (panelNode.offsetTop === MIDDLE_PANEL) {
                        panelNode.style.top = BOTTOM_PANEL + 'px';
                        panelNode.scrollTo(0, 0);
                    }
                }
                if (panelNode.style.top !== (BOTTOM_PANEL + 'px')) {
                    panelNode.style.overflowY = 'scroll';
                } else {
                    panelNode.style.overflowY = 'hidden';
                }
                panelNode.style.height = `calc(100vh - ${panelNode.style.top})`;
                this.widthTimer = true;
                setTimeout(() => {
                    this.widthTimer = false;
                }, 400);
            }
        },
        boxTouchEnd(e) {
            // let moveEndX = e.changedTouches[0].pageX;
            let moveEndY = e.changedTouches[0].pageY;
            // let X = moveEndX - this.startX;
            let Y = moveEndY - this.startY;
            if (Y > 0) {
                this.boxTouchMove('down');
            } else if (Y < 0) {
                this.boxTouchMove('up');
            }
        },
        closeDialog() {
            this.dialogVisible = false;
        }
    },
    mounted() {
        this.bindKeyDown(true);
        document.querySelector('#orderNoForm').focus();
        let orderNoFormMain = this.$route.query.orderNoFormMain;
        if (orderNoFormMain) {
            this.orderNoFormMain = orderNoFormMain;
            this.getData();
        }
        const that = this;
        window.onpopstate = () => {
            orderNoFormMain = this.$route.query.orderNoFormMain;
            if (orderNoFormMain) {
                that.orderNoFormMain = orderNoFormMain;
                that.getData();
            }
        };
        if (this.mobileWidth) {
            window.addEventListener('touchstart', this.boxTouchStart, false);
            // window.addEventListener('touchmove', this.boxTouchMove, false);
            window.addEventListener('touchend', this.boxTouchEnd, false);
        }
    },
    watch: {
        mobileWidth(val, old) {
            if (val !== old && val) {
                window.addEventListener('touchstart', this.boxTouchStart, false);
                // window.addEventListener('touchmove', this.boxTouchMove, false);
                window.addEventListener('touchend', this.boxTouchEnd, false);
            } else {
                window.removeEventListener('touchstart', this.boxTouchStart, false);
                // window.removeEventListener('touchmove', this.boxTouchMove, false);
                window.removeEventListener('touchend', this.boxTouchEnd, false);
            }
        }
    }
};
</script>
<style lang="less">
.order {
    padding-bottom: 1.5rem;
    min-height: 4.5rem;
    .search {
        margin: 0.4rem auto 0.26rem auto;
        width: 100%;
        input {
            width: 9.6rem;
            height: 0.6rem;
            background-color: #f6f6f6;
            border: 0;
            margin: 0 0.2rem;
            padding-left: 0.3rem;
            font-size: 18px;
            color: #333;
            &.error {
                border: 1px solid #ff8b00;
            }
        }
        button {
            width: 1.6rem;
            height: 0.6rem;
            background-color: #ff8b00;
            color: #ffffff;
            font-size: 20px;
            border: 0;
            cursor: pointer;
            &[disabled] {
                background-color: #999;
            }
        }
    }
    .error {
        color: #ff8b00;
        margin: 0.5rem auto 0.5rem 0.56rem;
    }
    .record-list {
        min-height: 3rem;
        margin-left: 0.2rem;
        font-size: 18px;
        .total-top {
            display: flex;
            justify-content: space-between;
        }
        .top-tip {
            margin-right: 8px;
            font-size: 17px;
            line-height: 24px;
            color: #999;
        }
        .total-title {
            margin-bottom: 0.06rem;
            margin-left: 0.16rem;
        }
        .order-title {
            margin-bottom: 0.15rem;
        }
        .important-info {
            color: #4285f5;
        }
    }
    .time-line {
        padding: 0 0 0.2rem 0.2rem;
        border-bottom: 1px solid #f0f0f0;
        background: #fafafa;
        border-top: 1px solid #f0f0f0;
    }
    .waybill-title {
        padding: 0.2rem 0.4rem 0.2rem 0.2rem;
        position: relative;
        cursor: pointer;
        background: #f0f0f0;
        color: #333333;
        &:after {
            content: "";
            width: 0.18rem;
            height: 0.18rem;
            position: absolute;
            right: 0.2rem;
            top: 0.25rem;
            background: url(../../images/icon/order-icon/stop.png) center
                no-repeat;
            background-size: 100%;
            transform: rotate(-180deg);
            clear: both;
        }
        &.opened:after {
            transform: none;
        }
        .open-text {
            float: right;
            font-size: 18px;
            color: #888888;
        }
        .custom-title-status {
            color: #fff;
            background: #4285f5;
            border-radius: 4px;
            margin-left: 0.2rem;
            padding: 0 0.1rem;
        }
    }
    .loading {
        height: 0.5rem;
        width: 0.5rem;
        margin: 0 auto;
    }
    .custom-order-container {
        padding: 0.2rem;
    }
    .custom-order-no {
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15);
        margin: 0.2rem 0.1rem 0 0;
    }
    .custom-title {
        padding: 0.12rem 0 0.2rem 0.2rem;
        border-bottom: solid 1px #f0f0f0;
    }
    .custom-title-color1 {
        color: #999999;
    }
    .custom-title-br {
        display: none;
    }
    .ustom-title-btn {
        margin-bottom: -0.03rem;
    }
    .el-dialog__title {
        font-size: 16px;
        font-weight: bold;
    }
    .el-dialog__body {
        padding: 10px 20px;
    }
    .el-input__inner {
        background: #f6f6f6;
        border: 1px solid #e1e5e6;
        margin-bottom: 20px;
    }
    .ver-img {
        display: flex;
        align-items: center;
        margin-right: 10px;
    }
    .refresh-img {
        width: 13px;
        margin: 0 10px;
        cursor: pointer;
    }
    .another-img {
        font-size: 12px;
        color: #4285f5;
        cursor: pointer;
    }
    .el-button--primary {
        background-color: #ff8b00;
        border-color: #ff8b00;
    }
    .el-button--default:hover {
        background-color: rgba(255, 139, 0, 0.1);
        border-color: rgba(255, 139, 0, 0.1);
        color: #ff8b00;
    }
}

@media screen and (min-width: 840px) and (max-width: 1079px) {
    .order {
        .search {
            input {
                font-size: 16px;
            }
            button {
                font-size: 18px;
            }
        }
    }
}

@media screen and (min-width: 481px) and (max-width: 839px) {
    .order {
        .search {
            input {
                font-size: 14px;
            }
            button {
                font-size: 16px;
            }
        }
        .record-list .order-title,
        .waybill-title {
            font-size: 14px;
        }
    }
}

@media screen and (max-width: 480px) {
    .order {
        padding: 0.15rem 0;
        height: calc(100vh - 0.6rem);
        padding-bottom: 0;
        .search {
            margin: 0 auto 0.14rem auto;
            width: 100%;
            display: flex;
            padding: 0 0.1rem;
            box-sizing: border-box;
            input {
                width: 75%;
                border-radius: 0.05rem;
                padding: 0 0 0 0.25rem;
                margin: 0 0.06rem 0 0;
                height: 0.28rem;
                border: 1px solid #f5f5f5;
                font-size: 14px;
                background: url(../../images/icon/icon_search_gray.png) 0.08rem
                    center no-repeat;
                background-size: 0.1rem 0.1rem;
            }
            button {
                width: 20%;
                height: 0.3rem;
                background-color: #ff8b00;
                border: 1px solid #ff8b00;
                border-radius: 0.05rem;
                font-size: 12px;
                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                &[disabled] {
                    border: 1px solid #999;
                }
            }
        }
        .error {
            font-size: 14px;
            margin: 0 0 0.2rem 0.2rem;
        }
        .record-list {
            margin-left: 0;
            font-size: 14px;
            line-height: 0.2rem;
            .total-title {
                margin-bottom: 0;
                font-size: 12px;
            }
            .total-top {
                display: block;
            }
            .top-tip {
                margin-left: 0.16rem;
                margin-bottom: 0.1rem;
                font-size: 11px;
                // line-height: 24px;
                color: #999;
            }
            .order-title {
                font-size: 14px;
            }
            .time-line {
                padding: 0;
                margin: 0;
            }
        }
        .waybill-title {
            font-size: 14px;
            padding: 0.06rem 0.1rem 0.1rem 0.1rem;
            &:before {
                width: 0.1rem;
                height: 0.1rem;
                top: 0.05rem;
            }
            .custom-title-status {
                display: inline-block;
                margin-left: 0;
                margin-top: 0.05rem;
            }
            .open-text {
                font-size: 12px;
                margin-right: 0.35rem;
            }
        }
        .waybill-list {
            margin-bottom: 0;
        }
        .loading {
            height: 0.25rem;
            width: 0.25rem;
        }
        .custom-order-no {
            margin: 0 0 0.15rem;
            box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.15);
            border-radius: 5px;
        }
        .custom-title {
            padding: 0.1rem;
            clear: both;
        }
        .ustom-title-btn {
            margin-top: 1px;
            float: right;
        }
        .custom-order-container {
            padding: 0;
            background: #f6f6f6;
        }
        .custom-title-br {
            display: inherit;
        }
        .mobile-ver-title {
            font-size: 16px;
            color: #ff3300;
            font-weight: bold;
            margin: 0 0 10px 10px;
        }
        .mobile-ver-code {
            margin: 0 10px;
        }
        .mobile-code-input {
            width: 47%;
            margin-right: 10px;
        }
        .mobile-ver-img {
            width: 27%;
            height: 100%;
            // border: 1px solid #979797;
        }
        .el-input__inner {
            margin-bottom: 0;
        }
    }
}
</style>
